import React, { useState } from 'react';
import style from './Image.module.css';
import { MdFullscreen } from "react-icons/md";
import parse from 'html-react-parser';
import { useSelector } from 'react-redux';

function Image({ src, alt, message }) {
  const { isChatFullScreen } = useSelector((state) => ({
    isChatFullScreen: state.messages.isChatFullScreen,
  }));

  const handleImage = (src, msg, fileType) => {
    sendMessageToParent({ type: 'IMAGE_SCREEN', url: src, caption: msg || '', fileType: fileType });
  };
  const sendMessageToParent = (message) => {
    window.parent.postMessage(message, '*');
  };
  return (
    <div
    className={`rcw-message-content ${!isChatFullScreen ? style.mainimagecontainer : ''}`}>
      <div className={style.imagecontainer}>
        <div className={style.imageFullScreenIcon}
          onClick={() => {
            handleImage(src, message, 'image');
          }}>
          <MdFullscreen/>
        </div>
        <img src={src == "" && !src ? './images/unnamed.jpg' : src} alt={alt} className={`${style.image} carousal-image`} />
      </div>
      {message && <p className={style.caption}>{parse(message)}</p>}
    </div>
  );
}

export default Image;
